import React, { useState, useEffect } from 'react';
import { auth } from './firebase';

const BACKEND_URL = 'https://pharmdev-rider.onrender.com';

const s = {
  card:    { backgroundColor: '#FFF', borderRadius: 12, padding: 18, border: '1px solid #E5E7EB' },
  statCard:{ backgroundColor: '#FFF', borderRadius: 12, padding: 18, border: '1px solid #E5E7EB', textAlign: 'center' },
  table:   { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th:      { padding: '12px 14px', textAlign: 'left', fontWeight: 600, color: '#555', borderBottom: '1px solid #E5E7EB', backgroundColor: '#F7F8FA', whiteSpace: 'nowrap' },
  td:      { padding: '10px 14px', borderBottom: '1px solid #F3F4F6', color: '#374151' },
};

function Badge({ text, bg, color }) {
  return <span style={{ backgroundColor: bg, color, padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{text}</span>;
}

export default function ReferralsTab() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState('');

  useEffect(() => { loadReferrals(); }, []);

  const loadReferrals = async () => {
    setLoading(true);
    setError('');
    try {
      const token = await auth.currentUser.getIdToken();
      const res = await fetch(`${BACKEND_URL}/admin/referrals`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Could not load referrals');
      setReferrals(data.referrals);
    } catch (e) {
      setError(e.message || 'Could not load referrals');
    } finally {
      setLoading(false);
    }
  };

  const rewarded = referrals.filter(r => r.status === 'rewarded');
  const flagged  = referrals.filter(r => r.flagged);
  const totalPaid = rewarded.length * 5;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontWeight: 700, margin: 0, fontSize: 20 }}>🎁 Referrals — PharmDev Faucet</h2>
          <p style={{ color: '#888', margin: '4px 0 0', fontSize: 13 }}>
            Every referral pair and payout. Flagged pairs share a phone number and were blocked before any reward could be paid.
          </p>
        </div>
        <button style={{ padding: '9px 16px', backgroundColor: '#1D9E75', color: '#FFF', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 13 }} onClick={loadReferrals}>
          ↻ Refresh
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 20 }}>
        <div style={s.statCard}>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#1A1A1A' }}>{referrals.length}</div>
          <div style={{ fontSize: 12, color: '#888' }}>Total referral signups</div>
        </div>
        <div style={s.statCard}>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#1D9E75' }}>{rewarded.length}</div>
          <div style={{ fontSize: 12, color: '#888' }}>Rewards paid</div>
        </div>
        <div style={s.statCard}>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#F59E0B' }}>GH₵ {totalPaid.toFixed(2)}</div>
          <div style={{ fontSize: 12, color: '#888' }}>Total paid out</div>
        </div>
        <div style={s.statCard}>
          <div style={{ fontSize: 24, fontWeight: 700, color: flagged.length ? '#EF4444' : '#1A1A1A' }}>{flagged.length}</div>
          <div style={{ fontSize: 12, color: '#888' }}>Flagged (phone match)</div>
        </div>
      </div>

      <div style={s.card}>
        {loading ? (
          <p style={{ color: '#888', textAlign: 'center', padding: 30 }}>Loading…</p>
        ) : error ? (
          <p style={{ color: '#EF4444', textAlign: 'center', padding: 30 }}>{error}</p>
        ) : referrals.length === 0 ? (
          <p style={{ color: '#888', textAlign: 'center', padding: 30 }}>No referrals yet.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Referrer</th>
                  <th style={s.th}>Referee</th>
                  <th style={s.th}>Code</th>
                  <th style={s.th}>Status</th>
                  <th style={s.th}>Signed up</th>
                  <th style={s.th}>Rewarded</th>
                </tr>
              </thead>
              <tbody>
                {referrals.map(r => (
                  <tr key={r.refereeUid} style={r.flagged ? { backgroundColor: '#FEF2F2' } : {}}>
                    <td style={s.td}>{r.referrerName || r.referrerUid} <span style={{ color: '#888' }}>{r.referrerPhone}</span></td>
                    <td style={s.td}>{r.refereeName || r.refereeUid} <span style={{ color: '#888' }}>{r.refereePhone}</span></td>
                    <td style={s.td}>{r.code}</td>
                    <td style={s.td}>
                      {r.flagged
                        ? <Badge text="⚠️ Flagged" bg="#FEE2E2" color="#B91C1C" />
                        : r.status === 'rewarded'
                          ? <Badge text="✅ Rewarded" bg="#E8F8F2" color="#1D9E75" />
                          : <Badge text="⏳ Pending" bg="#FEF3C7" color="#92400E" />}
                    </td>
                    <td style={s.td}>{r.signupAt ? new Date(r.signupAt).toLocaleDateString() : '—'}</td>
                    <td style={s.td}>{r.rewardedAt ? new Date(r.rewardedAt).toLocaleDateString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
